import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createGetRankingListOutbound } from '../api/outbound/commonOutbounds';
import { ExpandableSection } from '../components/expandableSection';
import { useSocketSend } from '../context/webSocket/webSocketContext';
import { ALL_EXPANDABLE_SECTION_PROPERTIES } from '../types/expandableSectionTypes';
import { ALL_MEDAL_PROPERTIES } from '../types/medalProperties';
import { ALL_RANKING_PROPERTIES, ALL_RANKING_TYPES } from '../types/rankingsTypes';
import { DrawerButton } from './drawerButton';
import { ExpandableSectionPaddedDrawerContainer } from './drawerControl';
const { svgIconComponent: SvgIconComponent } = ALL_EXPANDABLE_SECTION_PROPERTIES['drawer-rankings'];
export const RankingsExpandableDrawerSection = ({ closeDrawer }) => {
    const socketSend = useSocketSend();
    const onClickRankings = useCallback((rankingType) => {
        closeDrawer();
        socketSend(createGetRankingListOutbound(rankingType));
    }, [closeDrawer, socketSend]);
    return (_jsx(ExpandableSection, { expandableSectionType: 'drawer-rankings', colorType: 'drawer', children: _jsx(ExpandableSectionPaddedDrawerContainer, { children: ALL_RANKING_TYPES.map((rankingType) => {
                const { name: rankingName, medalType } = ALL_RANKING_PROPERTIES[rankingType];
                if (ALL_MEDAL_PROPERTIES[medalType].isDisabled) {
                    return null;
                }
                return (_jsx(DrawerButton, { label: rankingName, onClick: () => {
                        onClickRankings(rankingType);
                    }, startIcon: SvgIconComponent ? _jsx(SvgIconComponent, {}) : undefined }, rankingType));
            }) }) }));
};
